/**
 * @description Gestion des visuels selon device hp highlights
 */

/* global bsBreakpoints */

(() => {
  // VARS
  const breakpoint = bsBreakpoints.detectBreakpoint();
  const root = document.querySelector(".highlight__armentieres") || null;
  const visual = root ? root.querySelector(".highlight__bg") || null : "";

  // FONCTIONS

  const loadVisual = () => {
    const mobileImg = visual.getAttribute("data-mobile") || null;

    if ((breakpoint === "xSmall" || breakpoint === "small") && mobileImg) {
      visual.style.backgroundImage = `url(${mobileImg})`;
    }
  };

  // GO 🚀
  const init = () => {
    if (visual) {
      loadVisual();
    }
  };

  init();
})();
